import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import nl from './locales/nl.json';

// Get saved language from localStorage or default to English
// Use try-catch to handle SSR/build environments where localStorage may not be available
let savedLocale = 'en';
try {
  savedLocale = localStorage.getItem('locale') || 'en';
} catch (e) {
  // localStorage not available, use default
}

const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: 'en',
  messages: {
    en,
    nl
  },
  // Disable warnings in production
  silentTranslationWarn: process.env.NODE_ENV === 'production',
  silentFallbackWarn: process.env.NODE_ENV === 'production'
});

export default i18n;
